import React from "react";
import ReactDOM from "react-dom/client";

import "@fontsource-variable/urbanist";
import "@fontsource-variable/urbanist/wght-italic.css";
import "@fontsource-variable/epilogue";
import "@fontsource-variable/geist";
import "@fontsource-variable/dm-sans";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/700.css";

import "./index.style.scss";

import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { store } from "./Redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import App from "./App.component";
import ErrorBoundary from "./components-new/error-boundary/ErrorBoundary";
import { HelpProvider } from "./context/help-context";
import { RequestDataProvider } from "./app-2/context/RequestDataContext";
import "./utils/axiosInterceptor";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <HelpProvider>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <RequestDataProvider>
            <App />
            {window.location.hostname === "localhost" && (
              <ReactQueryDevtools initialIsOpen={false} />
            )}
          </RequestDataProvider>
        </QueryClientProvider>
      </Provider>
    </HelpProvider>
  </ErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
